// PublicRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";

const PublicRoute = ({ element }) => {
  //   const isAuthenticated = useIsAuthenticated();
  const isAuthenticated = useIsAuthenticated();

  return isAuthenticated ? <Navigate to="/" replace /> : element;
};

export default PublicRoute;
